import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type AlertFunctionType = {
    title: string,
    onClick: () => void,
    disabled: boolean
}

interface AlertActionTypes {
    title: string | null,
    description: string | null,
    functions: AlertFunctionType[] | [],
    sound: number
}

interface InitialStateTypes {
    title: string | null,
    description: string | null,
    functions: AlertFunctionType[] | [],
    sound: number,
    show: boolean
}


let initialState: InitialStateTypes = {
    title: null,
    description: null,
    functions: [],
    sound: 0,
    show: false
}

export const customAlertSlice = createSlice({
    name: 'customAlert',
    initialState,
    reducers: {
        setAlert(state, action: PayloadAction<AlertActionTypes>) {
            state.title = action.payload.title
            state.description = action.payload.description
            state.functions = action.payload.functions
            state.sound = action.payload.sound
            state.show = true
        },
        setShow(state, action: PayloadAction<boolean>) {
            state.show = action.payload
        }
    },
})


export const setAlert = (alert: AlertActionTypes) => customAlertSlice.actions.setAlert(alert)
export const setShow = (show: boolean) => customAlertSlice.actions.setShow(show)

export default customAlertSlice.reducer